var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { emit } from '@zapier/events-toolkit-browser';
export const UserInteractionEvent = 'web_analytics.tracking.user_interaction.UserInteractionEvent';
export var InteractionName;
(function (InteractionName) {
    InteractionName["plan_usage_click"] = "plan_usage_click";
})(InteractionName || (InteractionName = {}));
export var InteractionGoal;
(function (InteractionGoal) {
    InteractionGoal["plan_usage"] = "plan_usage";
})(InteractionGoal || (InteractionGoal = {}));
export const emitUserInteractionEvent = async (_a) => {
    var { interaction_name = 'call_to_action' } = _a, eventDetails = __rest(_a, ["interaction_name"]);
    return await emit(Object.assign(Object.assign({}, eventDetails), { absolute_url: window.location.pathname, interaction_name, referrer: document.referrer, system_name: 'design_system' }), UserInteractionEvent);
};
export const emitUserInteractionComponentInView = (interactionName, interactionGoal) => {
    return emit({
        event_action: 'in_view',
        absolute_url: window.location.pathname,
        interaction_name: interactionName,
        interaction_goal: interactionGoal,
        system_name: 'design_system',
        option_selected: 'not_applicable',
    }, UserInteractionEvent);
};
export const emitUserInteractionClick = (interactionName, interactionGoal, text, destinationHref) => {
    return emit({
        event_action: 'click',
        system_name: 'design_system',
        interaction_name: interactionName,
        interaction_goal: interactionGoal,
        option_selected: text,
        interaction_raw_text: text,
        destination_href: destinationHref,
        absolute_url: window.location.pathname,
    }, UserInteractionEvent);
};
export const emitUserInteractionHover = (interactionName, interactionGoal) => {
    return emit({
        event_action: 'hover',
        system_name: 'design_system',
        interaction_name: interactionName,
        interaction_goal: interactionGoal,
        option_selected: 'not_applicable',
        absolute_url: window.location.pathname,
    }, UserInteractionEvent);
};
//# sourceMappingURL=avroEvents.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
